import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import Logo from "./posties-logo.svg";

export const Container = styled.div`
  display: flex;
  justify-content: center;

  inline-size: 100%;
  margin-block-end: 32px;

  svg {
    inline-size: 302px;
    block-size: 48px;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 65px;
    svg {
      inline-size: 528px;
      block-size: 84px;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 40px;
  }
`;

export const PostiesLogo = styled(Logo)``;
